














import Vue, { PropOptions } from 'vue'
import Tab from './Tab.vue'
import { Tab as TabProps } from '../interfaces'

export default Vue.extend({
  name: 'tabs',
  components: { Tab },
  props: {
    tabs: {
      type: Array,
      default: () => [],
    } as PropOptions<TabProps[]>,
    activeTab: {
      type: String,
      default: () => '',
    },
    activeSubTabs: {
      type: Array,
      default: () => [],
    },
  },
  methods: {},
})
